// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import {
//   FaPython,
//   FaDatabase,
//   FaChartBar,
//   FaGraduationCap,
//   FaLaptopCode,
//   FaLightbulb,
//   FaBriefcase,
//   FaRocket,
//   FaBook,
// } from "react-icons/fa";

// const Datascience = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1200, once: true });
//   }, []);

//   const syllabus = [
//     {
//       title: "Module 1: Data Science Foundations",
//       topics: [
//         "Introduction to Data Science",
//         "Statistics & Probability",
//         "Data Types & Structures",
//         "Data Collection Methods",
//         "Research Methodology",
//       ],
//     },
//     {
//       title: "Module 2: Data Analysis & Visualization",
//       topics: [
//         "Exploratory Data Analysis",
//         "Data Cleaning & Preprocessing",
//         "Statistical Analysis",
//         "Data Visualization Techniques",
//         "Storytelling with Data",
//       ],
//     },
//     {
//       title: "Module 3: Machine Learning Basics",
//       topics: [
//         "Introduction to Machine Learning",
//         "Supervised Learning",
//         "Unsupervised Learning",
//         "Model Evaluation",
//         "Feature Engineering",
//       ],
//     },
//     {
//       title: "Module 4: Tools & Applications",
//       topics: [
//         "Python for Data Science",
//         "R Programming",
//         "SQL for Data Analysis",
//         "Big Data Concepts",
//         "Real-world Case Studies",
//       ],
//     },
//   ];

//   const tools = [
//     { icon: <FaPython />, name: "Python" },
//     { icon: <FaDatabase />, name: "SQL" },
//     { icon: <FaLaptopCode />, name: "Jupyter Notebook" },
//     { icon: <FaChartBar />, name: "Pandas" },
//     { icon: <FaChartBar />, name: "NumPy" },
//     { icon: <FaChartBar />, name: "Matplotlib" },
//     { icon: <FaChartBar />, name: "Seaborn" },
//     { icon: <FaLightbulb />, name: "Scikit-learn" },
//     { icon: <FaChartBar />, name: "Tableau" },
//   ];

//   const learners = [
//     { icon: <FaGraduationCap />, name: "Analytics enthusiasts" },
//     { icon: <FaBriefcase />, name: "Business professionals" },
//     {
//       icon: <FaGraduationCap />,
//       name: "Students with quantitative background",
//     },
//     { icon: <FaRocket />, name: "Career changers to data science" },
//     { icon: <FaLightbulb />, name: "Researchers and analysts" },
//   ];

//   const careers = [
//     {
//       icon: <FaBriefcase />,
//       title: "Data Scientist",
//       desc: "Build predictive models and extract insights from data.",
//     },
//     {
//       icon: <FaBriefcase />,
//       title: "Data Analyst",
//       desc: "Analyze datasets and visualize trends for decision-making.",
//     },
//     {
//       icon: <FaBriefcase />,
//       title: "Business Analyst",
//       desc: "Bridge business needs with data-driven solutions.",
//     },
//     {
//       icon: <FaBriefcase />,
//       title: "Research Analyst",
//       desc: "Conduct research and provide actionable insights.",
//     },
//     {
//       icon: <FaBriefcase />,
//       title: "Data Consultant",
//       desc: "Advise companies on analytics and data strategies.",
//     },
//     {
//       icon: <FaBriefcase />,
//       title: "Analytics Manager",
//       desc: "Lead teams in data-driven projects and strategy.",
//     },
//   ];

//   const outcomes = [
//     {
//       title: "Understand Data Science",
//       desc: "Learn methodology, workflow, and best practices.",
//     },
//     {
//       title: "Statistical Analysis",
//       desc: "Analyze data and extract insights.",
//     },
//     {
//       title: "Data Visualization",
//       desc: "Present data clearly using charts and graphs.",
//     },
//     {
//       title: "Machine Learning",
//       desc: "Build basic predictive models using Python.",
//     },
//     { title: "Data Handling", desc: "Work with large datasets efficiently." },
//     {
//       title: "Decision Making",
//       desc: "Make data-driven decisions with confidence.",
//     },
//   ];

//   const faq = [
//     {
//       question: "Do I need programming experience?",
//       answer:
//         "Basic programming knowledge is helpful but not mandatory. We'll guide you step-by-step.",
//     },
//     {
//       question: "What tools will I learn?",
//       answer:
//         "Python, R, SQL, Jupyter Notebook, Pandas, NumPy, Matplotlib, Seaborn, Scikit-learn, Tableau.",
//     },
//     {
//       question: "Is this course suitable for beginners?",
//       answer:
//         "Yes, the course starts with fundamentals and gradually moves to advanced topics.",
//     },
//   ];

//   // Background colors for cards (cycled)
//   const bgColors = [
//     "#ffe0e9",
//     "#e0f7fa",
//     "#fff3cd",
//     "#e6e6ff",
//     "#f0fff4",
//     "#fce4ec",
//     "#f3e5f5",
//     "#e8f5e9",
//     "#fffde7",
//   ];

//   return (
//     <div>
//       <style>{`
//         body { font-family: 'Poppins', sans-serif; margin: 0; padding: 0; background: #f5f6fa; color: #333; }
//         .container { width: 90%; max-width: 1200px; margin: auto; padding: 2rem 0; }

//         /* Animations */
//         @keyframes dance {
//           0%, 100% { transform: rotate(-3deg); }
//           50% { transform: rotate(3deg); }
//         }
//         @keyframes shake {
//           0%, 100% { transform: translateX(0); }
//           25% { transform: translateX(-4px); }
//           75% { transform: translateX(4px); }
//         }
//         .dance { animation: dance 2s infinite; }
//         .shake:hover { animation: shake 0.5s ease-in-out infinite; }

//         .hero-section { background: url('https://media.istockphoto.com/id/1389238948/photo/hand-touching-global-networking-on-data-connection-science-big-data-internet-technology.jpg?s=612x612&w=0&k=20&c=yCNE-b7vr1kD9iRAIH4Qq6J3ZRBalj_mCZVrNVsev50=') center/cover no-repeat; color: #fff; text-align: center; padding: 6rem 1rem; position: relative; }
//         .hero-section::before { content: ""; position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0,0,0,0.5); }
//         .hero-section .container { position: relative; z-index: 1; }
//         .hero-section h1 { font-size: 3rem; margin-bottom: 1rem; }
//         .btn { background: #ff6b6b; color: #fff; padding: 0.8rem 2rem; border-radius: 30px; font-weight: bold; text-decoration: none; display: inline-block; transition: transform 0.3s; }
//         .btn:hover { transform: scale(1.1); background: #e63946; }

//         section h2 { text-align: center; margin-bottom: 2rem; font-size: 2rem; }

//         .card, .module-card, .faq-card {
//           border-radius: 15px;
//           padding: 1.2rem;
//           box-shadow: 0 6px 15px rgba(0,0,0,0.1);
//           transition: transform 0.3s;
//         }
//         .card:hover, .module-card:hover, .faq-card:hover { transform: translateY(-5px) scale(1.03); }
//         .card-icon { font-size: 2rem; margin-bottom: 0.5rem; }

//         .about-course img { max-width: 400px; border-radius: 15px; box-shadow: 0 10px 20px rgba(0,0,0,0.2); transition: transform 0.3s; }
//         .about-course img:hover { transform: scale(1.05) rotate(2deg); }

//         .syllabus-cards, .tools-cards, .learners-cards, .careers-cards, .learning-outcomes-cards { display: grid; gap: 1rem; }
//         .syllabus-cards, .tools-cards, .learners-cards { grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); }
//         .careers-cards, .learning-outcomes-cards { grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); }
//       `}</style>

//       {/* Hero */}
//       <header className="hero-section">
//         <div className="container">
//           <h1 className="dance">Data Science Fundamentals</h1>
//           <p>
//             Comprehensive introduction to data science concepts, tools, and
//             methodologies
//           </p>
//           <a href="/contact" className="btn">
//             Enroll Now
//           </a>
//         </div>
//       </header>

//       {/* About */}
//       <section
//         className="about-course"
//         style={{ textAlign: "center", padding: "3rem 0" }}
//       >
//         <h2>About This Data Science Course</h2>
//         <img
//           className="shake"
//           src="https://i.pinimg.com/736x/77/8d/e3/778de3fb77cbd0a6e04b51aae0b53c66.jpg"
//           alt="Data Science"
//           style={{
//             display: "block",
//             margin: "1.5rem auto",
//             maxWidth: "400px",
//             borderRadius: "15px",
//           }}
//         />
//         <p style={{ maxWidth: "700px", margin: "1.5rem auto" }}>
//           Learn how to extract meaningful insights from large datasets using
//           modern tools like Python, Pandas, NumPy, Matplotlib, and Scikit-learn.
//         </p>
//       </section>

//       {/* Syllabus */}
//       <section className="course-syllabus">
//         <div className="container">
//           <h2>Course Syllabus</h2>
//           <div className="syllabus-cards">
//             {syllabus.map((module, idx) => (
//               <div
//                 key={idx}
//                 className="module-card"
//                 style={{
//                   background: bgColors[idx % bgColors.length],
//                   color: "#222",
//                 }}
//               >
//                 <h3>{module.title}</h3>
//                 <ul>
//                   {module.topics.map((topic, tidx) => (
//                     <li key={tidx}>{topic}</li>
//                   ))}
//                 </ul>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Tools */}
//       <section>
//         <div className="container">
//           <h2>Tools & Technologies</h2>
//           <div className="tools-cards">
//             {tools.map((tool, idx) => (
//               <div
//                 key={idx}
//                 className="card shake"
//                 style={{
//                   background: bgColors[idx % bgColors.length],
//                   color: "#222",
//                 }}
//               >
//                 <div className="card-icon">{tool.icon}</div>
//                 <h3>{tool.name}</h3>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Who Can Enroll */}
//       <section>
//         <div className="container">
//           <h2>Who Can Enroll</h2>
//           <div className="learners-cards">
//             {learners.map((learner, idx) => (
//               <div
//                 key={idx}
//                 className="card dance"
//                 style={{
//                   background: bgColors[idx % bgColors.length],
//                   color: "#222",
//                 }}
//               >
//                 <div className="card-icon">{learner.icon}</div>
//                 <h3>{learner.name}</h3>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Careers */}
//       <section>
//         <div className="container">
//           <h2>Career Opportunities</h2>
//           <div className="careers-cards">
//             {careers.map((career, idx) => (
//               <div
//                 key={idx}
//                 className="card shake"
//                 style={{
//                   background: bgColors[idx % bgColors.length],
//                   color: "#222",
//                 }}
//               >
//                 <div className="card-icon">{career.icon}</div>
//                 <h3>{career.title}</h3>
//                 <p>{career.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Outcomes */}
//       <section>
//         <div className="container">
//           <h2>What You'll Learn</h2>
//           <div className="learning-outcomes-cards">
//             {outcomes.map((item, idx) => (
//               <div
//                 key={idx}
//                 className="card dance"
//                 style={{
//                   background: bgColors[idx % bgColors.length],
//                   color: "#222",
//                 }}
//               >
//                 <div className="card-icon">
//                   <FaBook />
//                 </div>
//                 <h3>{item.title}</h3>
//                 <p>{item.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* FAQ */}
//       <section>
//         <div className="container">
//           <h2>Frequently Asked Questions</h2>
//           {faq.map((q, idx) => (
//             <div
//               key={idx}
//               className="faq-card shake"
//               style={{
//                 background: bgColors[idx % bgColors.length],
//                 color: "#222",
//               }}
//             >
//               <h3>{q.question}</h3>
//               <p>{q.answer}</p>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Datascience;

import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaPython,
  FaDatabase,
  FaChartBar,
  FaGraduationCap,
  FaLaptopCode,
  FaLightbulb,
  FaBriefcase,
  FaChevronDown,
  FaChevronUp,
  FaRocket,
  FaBook,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const Datascience = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (idx) => {
    setOpenFAQ(openFAQ === idx ? null : idx);
  };

  const syllabus = [
    {
      title: "Module 1: Data Science Foundations",
      topics: [
        "Introduction to Data Science",
        "Statistics & Probability",
        "Data Types & Structures",
        "Data Collection Methods",
        "Research Methodology",
      ],
    },
    {
      title: "Module 2: Data Analysis & Visualization",
      topics: [
        "Exploratory Data Analysis",
        "Data Cleaning & Preprocessing",
        "Statistical Analysis",
        "Data Visualization Techniques",
        "Storytelling with Data",
      ],
    },
    {
      title: "Module 3: Machine Learning Basics",
      topics: [
        "Introduction to Machine Learning",
        "Supervised Learning",
        "Unsupervised Learning",
        "Model Evaluation",
        "Feature Engineering",
      ],
    },
    {
      title: "Module 4: Tools & Applications",
      topics: [
        "Python for Data Science",
        "R Programming",
        "SQL for Data Analysis",
        "Big Data Concepts",
        "Real-world Case Studies",
      ],
    },
  ];

  const tools = [
    { icon: <FaPython />, name: "Python" },
    { icon: <FaDatabase />, name: "SQL" },
    { icon: <FaLaptopCode />, name: "Jupyter Notebook" },
    { icon: <FaChartBar />, name: "Pandas" },
    { icon: <FaChartBar />, name: "NumPy" },
    { icon: <FaChartBar />, name: "Matplotlib" },
    { icon: <FaChartBar />, name: "Seaborn" },
    { icon: <FaLightbulb />, name: "Scikit-learn" },
    { icon: <FaChartBar />, name: "Tableau" },
  ];

  const learners = [
    { icon: <FaGraduationCap />, name: "Analytics enthusiasts" },
    { icon: <FaBriefcase />, name: "Business professionals" },
    {
      icon: <FaGraduationCap />,
      name: "Students with quantitative background",
    },
    { icon: <FaRocket />, name: "Career changers to data science" },
    { icon: <FaLightbulb />, name: "Researchers and analysts" },
  ];

  const careers = [
    {
      icon: <FaBriefcase />,
      title: "Data Scientist",
      desc: "Build predictive models and extract insights from data.",
    },
    {
      icon: <FaBriefcase />,
      title: "Data Analyst",
      desc: "Analyze datasets and visualize trends for decision-making.",
    },
    {
      icon: <FaBriefcase />,
      title: "Business Analyst",
      desc: "Bridge business needs with data-driven solutions.",
    },
    {
      icon: <FaBriefcase />,
      title: "Research Analyst",
      desc: "Conduct research and provide actionable insights.",
    },
    {
      icon: <FaBriefcase />,
      title: "Data Consultant",
      desc: "Advise companies on analytics and data strategies.",
    },
    {
      icon: <FaBriefcase />,
      title: "Analytics Manager",
      desc: "Lead teams in data-driven projects and strategy.",
    },
  ];

  const outcomes = [
    {
      title: "Understand Data Science",
      desc: "Learn methodology, workflow, and best practices.",
    },
    {
      title: "Statistical Analysis",
      desc: "Analyze data and extract insights.",
    },
    {
      title: "Data Visualization",
      desc: "Present data clearly using charts and graphs.",
    },
    {
      title: "Machine Learning",
      desc: "Build basic predictive models using Python.",
    },
    { title: "Data Handling", desc: "Work with large datasets efficiently." },
    {
      title: "Decision Making",
      desc: "Make data-driven decisions with confidence.",
    },
  ];

  const faq = [
    {
      question: "Do I need programming experience?",
      answer:
        "Basic programming knowledge is helpful but not mandatory. We'll guide you step-by-step.",
    },
    {
      question: "What tools will I learn?",
      answer:
        "Python, R, SQL, Jupyter Notebook, Pandas, NumPy, Matplotlib, Seaborn, Scikit-learn, Tableau.",
    },
    {
      question: "Is this course suitable for beginners?",
      answer:
        "Yes, the course starts with fundamentals and gradually moves to advanced topics.",
    },
  ];

  const bgColors = [
    "#ffe0e9",
    "#e0f7fa",
    "#fff3cd",
    "#e6e6ff",
    "#f0fff4",
    "#fce4ec",
    "#f3e5f5",
    "#e8f5e9",
    "#fffde7",
  ];

  return (
    <div className="overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

        body { font-family: 'Roboto', sans-serif; margin: 0; padding: 0; background: #f5f6fa; color: #333; }
        .container { width: 90%; max-width: 1200px; margin: auto; padding: 2rem 0; }

        @keyframes dance {
          0%, 100% { transform: rotate(-3deg); }
          50% { transform: rotate(3deg); }
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-4px); }
          75% { transform: translateX(4px); }
        }
        .dance { animation: dance 2s infinite; }
        .shake:hover { animation: shake 0.5s ease-in-out infinite; }

        .hero-section { background: url('https://media.istockphoto.com/id/1389238948/photo/hand-touching-global-networking-on-data-connection-science-big-data-internet-technology.jpg?s=612x612&w=0&k=20&c=yCNE-b7vr1kD9iRAIH4Qq6J3ZRBalj_mCZVrNVsev50=') center/cover no-repeat; color: #fff; text-align: center; padding: 6rem 1rem; position: relative; }
        .hero-section::before { content: ""; position: absolute; top:0; left:0; width:100%; height:100%; background: rgba(0,0,0,0.5); }
        .hero-section .container { position: relative; z-index: 1; }
        .hero-section h1 { font-size: 3rem; margin-bottom: 1rem; }
        .btn { background: #ff6b6b; color: #fff; padding: 0.8rem 2rem; border-radius: 30px; font-weight: bold; text-decoration: none; display: inline-block; transition: transform 0.3s; }
        .btn:hover { transform: scale(1.1); background: #e63946; }

        section h2 { text-align: center; margin-bottom: 2rem; font-size: 2rem; }

        .card, .module-card, .faq-card {
          border-radius: 15px;
          padding: 1.2rem;
          box-shadow: 0 6px 15px rgba(0,0,0,0.1);
          transition: transform 0.3s;
        }
        .card:hover, .module-card:hover, .faq-card:hover { transform: translateY(-5px) scale(1.03); }
        .card-icon { font-size: 2rem; margin-bottom: 0.5rem; }

        /* About Section Grid */
        .about-course { display: grid; grid-template-columns: 1fr 1fr; align-items: center; gap: 2rem; padding: 3rem 0; }
        .about-course img { width: 100%; border-radius: 15px; box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
        .about-content { text-align: left; }

        .syllabus-cards, .tools-cards, .learners-cards, .careers-cards, .learning-outcomes-cards { display: grid; gap: 1rem; }
        .syllabus-cards, .tools-cards, .learners-cards { grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); }
        .careers-cards, .learning-outcomes-cards { grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); }

        /* FAQ Styles */
        .faq-card { margin-bottom: 1rem; }
        .faq-question { display: flex; justify-content: space-between; align-items: center; cursor: pointer; font-weight: bold; }
        .faq-answer { margin-top: 0.5rem; display: none; }
        .faq-answer.open { display: block; }
        .faq-btn { background: #007bff; color: #fff; border: none; padding: 0.5rem 1rem; border-radius: 8px; cursor: pointer; transition: 0.3s; }
        .faq-btn:hover { background: #0056b3; }
      `}</style>

      {/* Hero */}
      <header className="hero-section">
        <div className="container">
          <h1 className="animate-float">Data Science Fundamentals</h1>
          <p>
            Comprehensive introduction to data science concepts, tools, and
            methodologies
          </p>
          <Link to="/contact" className="btn mt-3">
            Enroll Now
          </Link>
        </div>
      </header>

      {/* About */}
      <section
        className="about-course"
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: "30px",
          padding: "40px 20px",
        }}
      >
        {/* Image */}
        <div
          style={{
            flex: "1 1 300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="/assets/778de3fb77cbd0a6e04b51aae0b53c66.jpg"
            alt="Data Science"
            style={{
              width: "100%",
              maxWidth: "600px",
              height: "auto",
              borderRadius: "10px",
            }}
          />
        </div>

        {/* Text Content */}
        <div
          className="about-content"
          style={{
            flex: "1 1 300px",
            textAlign: "justify",
            maxWidth: "600px",
          }}
        >
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              marginBottom: "1.5rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            About This Data Science Course
          </h2>
          <p>
            This course is designed to give you a strong foundation in the world
            of data science. You’ll start with the fundamentals of statistics,
            probability, and data handling, and gradually build up to modern
            tools and techniques used in the industry.
          </p>
          <p>
            You will gain hands-on experience with Python, Pandas, NumPy,
            Matplotlib, Seaborn, and Scikit-learn while working on real-world
            case studies. The course also emphasizes the importance of
            storytelling with data, helping you clearly communicate insights to
            stakeholders.
          </p>
          <p>
            By the end of this course, you will be confident in analyzing
            datasets, building predictive models, and applying data-driven
            decision-making to solve business and research problems.
          </p>
        </div>
      </section>

      {/* Syllabus */}
      <section className="course-syllabus">
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              marginBottom: "1.5rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Course Syllabus
          </h2>
          <div className="syllabus-cards">
            {syllabus.map((module, idx) => (
              <div
                key={idx}
                className="module-card animate-pluse"
                style={{
                  background: bgColors[idx % bgColors.length],
                  color: "#222",
                }}
              >
                <h3>{module.title}</h3>
                <ul>
                  {module.topics.map((topic, tidx) => (
                    <li key={tidx}>{topic}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tools */}
      <section>
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              marginBottom: "1.5rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-down"
          >
            Tools & Technologies
          </h2>
          <div className="tools-cards">
            {tools.map((tool, idx) => (
              <div
                key={idx}
                className="card shake animate-float"
                style={{
                  background: bgColors[idx % bgColors.length],
                  color: "#222",
                }}
              >
                <div className="card-icon">{tool.icon}</div>
                <h3>{tool.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who Can Enroll */}
      <section>
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              marginBottom: "1.5rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Who Can Enroll
          </h2>
          <div className="learners-cards">
            {learners.map((learner, idx) => (
              <div
                key={idx}
                className="card dance "
                style={{
                  background: bgColors[idx % bgColors.length],
                  color: "#222",
                }}
              >
                <div className="card-icon">{learner.icon}</div>
                <h3>{learner.name}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Careers */}
      <section>
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              marginBottom: "1.5rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Career Opportunities
          </h2>
          <div className="careers-cards">
            {careers.map((career, idx) => (
              <div
                key={idx}
                className="card shake animate-shake"
                style={{
                  background: bgColors[idx % bgColors.length],
                  color: "#222",
                }}
              >
                <div className="card-icon ">{career.icon}</div>
                <h3>{career.title}</h3>
                <p>{career.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Outcomes */}
      <section>
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              marginBottom: "1.5rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            What You'll Learn
          </h2>
          <div className="learning-outcomes-cards">
            {outcomes.map((item, idx) => (
              <div
                key={idx}
                className="card dance"
                style={{
                  background: bgColors[idx % bgColors.length],
                  color: "#222",
                }}
              >
                <div className="card-icon">
                  <FaBook />
                </div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* FAQ */}
      <section>
        <div className="container">
          <h2
            style={{
              fontSize: "1.8rem",
              fontWeight: 600,
              marginBottom: "1.5rem",
              color: "#000",
              textAlign: "center",
            }}
            data-aos="fade-up"
          >
            Frequently Asked Questions
          </h2>
          {faq.map((q, idx) => (
            <div
              key={idx}
              className="faq-card"
              style={{
                background: bgColors[idx % bgColors.length],
                color: "#222",
              }}
            >
              <div className="faq-question" onClick={() => toggleFAQ(idx)}>
                <span>{q.question}</span>
                <button className="faq-btn">
                  {openFAQ === idx ? <FaChevronUp /> : <FaChevronDown />}
                </button>
              </div>
              <div className={`faq-answer ${openFAQ === idx ? "open" : ""}`}>
                <p>{q.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Datascience;
